import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import useAuthSync from "@hooks/useAuthSync";

const ProtectedRoute = ({ redirectPath = "/login" }) => {
  const { loading } = useAuthSync();
  const memberInfoData = useSelector((state) => state.memberInfo.memberInfoData);
  // Nic Wong: I added a loading state to prevent the route from rendering before the auth state is determined. This prevents a flash of the protected content before redirecting to login.
  if (loading) {
    return null;
  }
  const isLoggedIn = !!memberInfoData;
  return isLoggedIn ? <Outlet /> : <Navigate to={redirectPath} replace />;
};

export default ProtectedRoute;